<template>
  <ConfirmationModal
    bodyText=""
    cancelText=""
    continueText="Got It"
    headerText="You discovered a Platform Plus Feature!"
    kbLink="https://jumpcloud.com/fair-use-policy"
    kbLinkText="Check out our Fair Use Policy"
  >
    <template v-slot:message>
      <p>
        {{ pluralFeatureName }} are part of JumpCloud’s
        <strong :class="$style.emphasize">Platform Plus</strong> subscription
      </p>
      <ul>
        <li
          v-for="feature in features"
          :key="feature.name"
          :class="$style.listItem"
        >
          <strong>{{ feature.name }} </strong>
          <span>{{ feature.description }}</span>
        </li>
      </ul>
      <p :class="$style.details">
        We encourage you to experiment with it even if your organization isn’t
        on the Platform Plus subscription so you can determine whether it will work
        for you. If you love it, contact your CSM or email
        <a href="mailto:accounts@jumpcloud.com">accounts@jumpcloud.com</a> to
        ensure uninterrupted use by upgrading your subscription. We’ll also follow up
        with you periodically to discuss the addition of new features you’re using to
        your subscription.
      </p>
    </template>
  </ConfirmationModal>
</template>
<script>
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';

export default {
  name: 'PlatformPlusModal',

  components: {
    ConfirmationModal,
  },

  props: {
    features: {
      type: Array,
      default: () => [],
    },
    pluralFeatureName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style module>
  @value ( jcInformationalBase ) from '~css/brand-colors.css';

  .details.details {
    margin: 50px 0 20px 0;
  }

  .listItem {
    margin-bottom: 20px;
  }

  .emphasize {
    color: jcInformationalBase;
  }
</style>
